import React from 'react';

import { Content } from './Content.js';

export default class SplitPipePanel extends React.Component {

    render() {
        var googleMapsUrl = this._generateGoogleMapsUrl(
          Content[this.props.page][this.props.office].mapUrl
        );

        return (
          <div className={`SplitPipePanel row ${this.props.office}`}>
            <div className="col-xs-16">
              <div className="image-container">
                <span className="region">{Content[this.props.page][this.props.office].region}</span>
                <h1>{Content[this.props.page][this.props.office].title}</h1>
              </div>
              <div className="office-container">
                <div className="office-details">
                  <div className="address">
                    <address>
                      <div className="postal-address">
                        <div className="cell">
                          <a href={googleMapsUrl} target="_blank">
    {Content[this.props.page][this.props.office].address1}<br/>
    {Content[this.props.page][this.props.office].address2}<br/>
    {Content[this.props.page][this.props.office].address3}<br/>
    {Content[this.props.page][this.props.office].address4}
    {Content[this.props.page][this.props.office].address5}<br/>
    {Content[this.props.page][this.props.office].address6}
                          </a>
                        </div>
                      </div>
                      <div className="tel">
                        <div className="cell">
                          <a href={`tel:${Content[this.props.page][this.props.office].phone}`}>{Content[this.props.page][this.props.office].phone}</a>
                    </div>
                  </div>
                </address>
              </div>
              <div className="map">
			  <iframe src={googleMapsUrl} width="100%" height="100%">
                
				</iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

  _generateGoogleMapsUrl(mapUrl) {
    return mapUrl
}

};
